import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// The service worker will cache assets in the user's browser to make loading quick in the future.
registerServiceWorker();
